import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FilterService } from '@progress/kendo-angular-grid';
import { FilterDescriptor } from '@progress/kendo-data-query';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

@Component({
    selector: 'app-droplist-filter',
    templateUrl: './droplist-filter.component.html',
    styleUrls: ['./droplist-filter.component.scss'],
    standalone: false
})
export class DroplistFilterComponent implements AfterViewInit {
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() public currentFilter: any;
  @Input() public data: (number | string | IReferenceData)[];
  @Input() public textField: string;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() public valueField: any;
  @Input() public filterService: FilterService;
  @Input() public field: string;
  @Output() public valueChange: EventEmitter<
    (string | number | IReferenceData)[]
  > = new EventEmitter<(number | string | IReferenceData)[]>();
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  public currentData: any;
  public showFilter: boolean = true;
  public value: number;

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  public onValueChange(value: any): void {
    const TRUE_VALUE: string | number =
      typeof value === 'object' ? value.id : value;

    this.filterService.filter({
      filters: [{ field: this.field, operator: 'eq', value: TRUE_VALUE }],
      logic: 'and',
    });
  }

  public ngAfterViewInit(): void {
    this.currentData = this.data;
    const CURRENT_COLUMN_FILTER: FilterDescriptor =
      this.currentFilter.filters.find(
        (filter: FilterDescriptor) => filter.field === this.field
      );
    if (CURRENT_COLUMN_FILTER) {
      this.value = CURRENT_COLUMN_FILTER.value;
    }
  }
}
